import React, { useEffect, useState } from 'react';

import TimeComp from './TimeComp';
import WeekDaysComp from './WeekDaysComp';

interface IWeeklyProps {
	days: string;
	startsAtHour: string | number;
	startsAtMinutes: string | number;
}
interface IWeeklyCompProps {
	handleChange: (val: IWeeklyProps) => void;
}

const WeeklyComp = (props: IWeeklyCompProps) => {
	const { handleChange } = props;

	const [hour, setHour] = useState<string | number>('12');
	const [minutes, setMinutes] = useState<string | number>('00');
	const [days, setDays] = useState<string>('');

	const handleWeekDays = (val: string) => {
		setDays(val);
	};
	const handleHourChange = (val: string | number) => {
		setHour(val);
	};

	const handleMinuteChange = (val: string | number) => {
		setMinutes(val);
	};

	useEffect(() => {
		if (days !== undefined || hour !== undefined || minutes !== undefined) {
			const obj = {
				days,
				startsAtHour: hour,
				startsAtMinutes: minutes,
			};
			handleChange(obj);
		}
	}, [days, hour, minutes]);
	return (
		<>
			<WeekDaysComp handleWeekDays={handleWeekDays} />
			<TimeComp
				handleHourChange={handleHourChange}
				handleMinuteChange={handleMinuteChange}
			/>
		</>
	);
};

export default WeeklyComp;
